type Milestone = { year: string; desc: string };

// 공공데이터포털 위탁운영(2년 주기 운영 계약)
const OPERATION: Milestone[] = [
  { year: '2025 ~ 2026', desc: '공공데이터포털 및 대국민 서비스 위탁운영' },
  { year: '2023 ~ 2024', desc: '공공데이터포털 및 서비스 위탁운영' },
  { year: '2021 ~ 2022', desc: '공공데이터포털 운영 및 유지관리' },
  { year: '2020', desc: '범정부 데이터 플랫폼 통합 운영·유지보수' },
  { year: '2019', desc: '공공데이터포털(data.go.kr) 위탁 운영·서비스 개선' },
  { year: '2016 ~ 2017', desc: '공공데이터포털 위탁운영·서비스 개선' },
];

// 데이터 개방·구축(신규 데이터셋 개방·개방체계 구축) 프로젝트
const OPENING: Milestone[] = [
  { year: '2025', desc: '디지털서비스 개방 API 개발 지원, 법령해석·재결례 개방체계 구축(2차)' },
  { year: '2024', desc: '중앙부처 법령해석·특별행정심판 재결례 개방체계 구축' },
  { year: '2023', desc: '사업용차량 이력정보·SRT 지연승차권 등 신규 데이터 개방' },
  { year: '2022', desc: '수요자 중심 공공데이터 개방활용 체계 개선' },
  { year: '2021', desc: '금융표준종합정보 DB 개방 확대·사업자등록정보 진위확인' },
  { year: '2020', desc: '데이터SOS·Open API 통합 서비스 기반 구축' },
];

const GROUPS: { title: string; items: Milestone[] }[] = [
  { title: '포털 위탁운영', items: OPERATION },
  { title: '데이터 개방·구축', items: OPENING },
];

/**
 * 연혁 — 공공데이터 사업을 '포털 위탁운영'과 '데이터 개방·구축' 두 갈래로 나눠 표기한다.
 * (운영 타임라인에 개방 사업이 섞이지 않도록 분리)
 */
export default function HistoryTimeline() {
  return (
    <section className="pd-section pd-history">
      <div className="pd-container">
        <div className="pd-head">
          <span className="pd-eyebrow pd-eyebrow--plain">MILESTONES</span>
          <h2 className="pd-h2">공공데이터 사업의 발자취</h2>
        </div>

        <div className="pd-history__groups">
          {GROUPS.map((g) => (
            <div className="pd-history__group" key={g.title}>
              <h3 className="pd-history__subtitle">{g.title}</h3>
              <div className="pd-history__list">
                {g.items.map((m) => (
                  <div className="pd-history__item" key={`${g.title}-${m.year}`}>
                    <div className="pd-history__year">{m.year}</div>
                    <div className="pd-history__desc">{m.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
